// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__33l5a","Icon":"Toolbar_Icon__2cYSD","Hamburger":"Toolbar_Hamburger__3sKeK","Avatar":"Toolbar_Avatar__3_n2D"};